module.exports = __webpack_public_path__ + "img/like.87c50bb2.svg";